interface AddressComponent {
    long_name: string;
    short_name: string;
    types: string[];
}

interface AddressData {
    street_number: string
    route: string
    city: string
    state: string
    postal_code: string
    country: string
}

export interface StripeCustomer {
    id: string;
    object: string;
    address?: {
        city: string;
        country: string;
        line1: string;
        line2?: string;
        postal_code: string;
        state: string;
    };
    balance?: number;
    created: number;
    currency?: string;
    default_source?: string;
    description?: string;
    email?: string;
    invoice_prefix?: string;
    invoice_settings?: {
        custom_fields?: Array<{
            name: string;
            value: string;
        }>;
        default_payment_method?: string;
        footer?: string;
    };
    livemode: boolean;
    metadata?: {
        [key: string]: string;
    };
    name?: string;
    phone?: string;
    preferred_locales?: string[];
    shipping?: {
        address: {
            city: string;
            country: string;
            line1: string;
            line2?: string;
            postal_code: string;
            state: string;
        };
        name: string;
        phone: string;
    };
    sources?: {
        object: string;
        data: any[];
        has_more: boolean;
        total_count: number;
        url: string;
    };
}


export function convertAddressComponents(addressComponents: AddressComponent[]): AddressData {
    let addressDict: AddressData | any = {};
    addressComponents.forEach(component => {
        component.types.forEach(type => {
            switch (type) {
                case 'street_number':
                    addressDict.street_number = component.long_name;
                    break;
                case 'route':
                    addressDict.route = component.short_name;
                    break;
                case 'locality':
                case 'sublocality':
                    addressDict.city = component.long_name;
                    break;
                case 'administrative_area_level_1':
                    addressDict.state = component.short_name;
                    break;
                case 'postal_code':
                    addressDict.postal_code = component.long_name;
                    break;
                case 'country':
                    addressDict.country = component.short_name;
                    break;
                default:
                    break;
            }
        });
    })

    return addressDict;
}


const prices = [
    {
        square_feet: "0 - 500",

    },
    {
        square_feet: "501 - 1,000",

    },
    {
        square_feet: "1,001 - 1,500",

    },
    {
        square_feet: "1,501 - 2,000",

    },
    {
        square_feet: "2,001 - 2,500",

    },
    {
        square_feet: "2,501 - 3,000",

    },
    {
        square_feet: "3,001 - 3,500",

    },
    {
        square_feet: "3,501 - 4,000",

    },
    {
        square_feet: "4,001 - 4,500",

    },
    {
        square_feet: "4,501 - 5,000",

    },
    {
        square_feet: "5,001 - 5,500",

    },
    {
        square_feet: "5,501 - 6,000",

    },
    {
        square_feet: "6,001 - 6,500",

    },
    {
        square_feet: "6,501 - 7,000",

    },
    {
        square_feet: "7,001 - 7,500",

    },
    {
        square_feet: "7,501 - 8,000",

    },
    {
        square_feet: "8,001 - 8,500",

    },
    {
        square_feet: "8,501 - 9,000",

    },
    {
        square_feet: "9,001 - 9,500",

    },
    {
        square_feet: "9,501 - 10,000",

    },
    {
        square_feet: "10,001 - 10,500",

    },
    {
        square_feet: "10,501 - 11,000",

    },
    {
        square_feet: "11,001 - 11,500",

    },
    {
        square_feet: "11,501 - 12,000",

    },
    {
        square_feet: "12,001 - 12,500",

    },
    {
        square_feet: "12,501 - 13,000",

    },
    {
        square_feet: "13,001 - 13,500",

    },
    {
        square_feet: "13,501 - 14,000",

    },
    {
        square_feet: "14,001 - 14,500",

    },
    {
        square_feet: "14,501 - 15,000",

    },
    {
        square_feet: "15,001 - 15,500",

    },
    {
        square_feet: "15,501 - 16,000",

    },
    {
        square_feet: "16,001 - 16,500",

    },
    {
        square_feet: "16,501 - 17,000",

    },
    {
        square_feet: "17,001 - 17,500",

    },
    {
        square_feet: "17,501 - 18,000",

    },
    {
        square_feet: "18,001 - 18,500",

    },
    {
        square_feet: "18,501 - 19,000",

    },
    {
        square_feet: "19,001 - 19,500",

    },
    {
        square_feet: "19,501 - 20,000",

    }
];

export function findPriceInRange(number: number) {
    for (let object of prices) {
        // Extract the range string
        let range = object.square_feet;

        // Split the range string into minimum and maximum values
        let [min, max] = range.split(' - ').map(value => parseInt(value.replace(',', ''))); // Remove commas if present

        // Check if the number is within the range
        if (number >= min && number <= max) {
            return object;
        }
    }

    // Return null if no object is found within the range
    return null;
}

export function formatPrice(price: number) {


    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    return USDollar.format(price / 100);
}

export const API_URL = process.env.NODE_ENV === 'production' ? '/wp-json/nr-lawn-logic/v1' : 'http://localhost/wp-json/nr-lawn-logic/v1';


export function getLawnLotSize(propertyLotSize: number) {
    if (propertyLotSize <= 5000) {
        return propertyLotSize * 0.32;
    } else if (propertyLotSize > 5000 && propertyLotSize <= 10000) {
        return propertyLotSize * 0.37;
    } else {
        return propertyLotSize * 0.42;
    }

}

export function sqMtrsToSqFt(sqMtrs: number) {
    return Math.ceil(sqMtrs * 10.7639);
}
export function getRandomHighlightColor() {
    // Generate random values for hue, saturation, and lightness components
    var h = Math.floor(Math.random() * 360); // Random value between 0 and 359 (hue)
    var s = Math.floor(Math.random() * 50) + 50; // Random value between 50 and 100 (saturation)
    var l = Math.floor(Math.random() * 50) + 50; // Random value between 50 and 100 (lightness)

    // Convert HSL to RGB
    var c = (1 - Math.abs(2 * l - 1)) * s / 100;
    var x = c * (1 - Math.abs((h / 60) % 2 - 1));
    var m = l / 100 - c / 2;
    var r, g, b;

    if (h < 60) {
        r = c;
        g = x;
        b = 0;
    } else if (h < 120) {
        r = x;
        g = c;
        b = 0;
    } else if (h < 180) {
        r = 0;
        g = c;
        b = x;
    } else if (h < 240) {
        r = 0;
        g = x;
        b = c;
    } else if (h < 300) {
        r = x;
        g = 0;
        b = c;
    } else {
        r = c;
        g = 0;
        b = x;
    }

    // Adjust RGB values to integers between 0 and 255
    r = Math.round((r + m) * 255);
    g = Math.round((g + m) * 255);
    b = Math.round((b + m) * 255);

    // Construct the RGB color string
    var color = 'rgb(' + r + ',' + g + ',' + b + ')';

    return color;
}